/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import NotificationSystem from 'rc-notification'
import SpotifyIcon from 'mdi-react/SpotifyIcon'
import { useDebouncedCallback } from 'use-debounce'

import { FullWideNotification } from 'Shared/components/Notification'
import logo from 'Shared/img/logo.png'
import { getCookieByName, getUtmParameters } from 'Constants/functions'
import { APP } from 'Configs/App'

import SignUpForm from './components/SignUpForm'
import {
  locationEvent,
  signUpEvent,
  curatorRegistrationStartEvent,
} from '../../Helpers/tagManager'

let notification = null

const showNotification = message => {
  notification.notice({
    content: <FullWideNotification color="danger" message={message} />,
    position: 'full',
    duration: 20,
    closable: true,
    style: { top: 0, left: 0 },
    className: `ltr-support`,
  })
}

const SignUp = ({
  //  eslint-disable-next-line @typescript-eslint/no-explicit-any
  location,
  formStates,
  onSignUpArtist,
  onSignUpCurator,
  history,
}) => {
  const { t } = useTranslation()
  const [submitDisabled, setSubmitDisabled] = useState(false)

  const role = location.pathname.slice(8)

  useEffect(() => {
    // role && signUpEvent(role)
    locationEvent()

    if (role.includes('curator')) {
      curatorRegistrationStartEvent()
    }
  }, [role])

  const handleSubmit = () => {
    const { firstName, lastName, email, password } = formStates
    const fullGcid = getCookieByName('_ga')
    const gcid = fullGcid ? fullGcid.slice(6) : undefined
    const utmStr = getCookieByName('soundCampaignUtm')
    const utmObj = getUtmParameters(utmStr)

    role.includes('curator')
      ? onSignUpCurator(firstName, lastName, password, email, error => {
          if (error) {
            NotificationSystem.newInstance(
              { style: { top: 65 } },
              n => (notification = n)
            )
            showNotification(t('signup.emailIsUsed'))
          }
          signUpEvent(role)
        })
      : onSignUpArtist(
          firstName,
          lastName,
          password,
          email,
          gcid,
          utmObj,
          error => {
            if (error) {
              NotificationSystem.newInstance(
                { style: { top: 65 } },
                n => (notification = n)
              )
              showNotification(t('signup.emailIsUsed'))
            } else {
              signUpEvent(role)
              history.push('/campaigns')
            }
          }
        )
  }

  const [debouncedSubmit] = useDebouncedCallback(() => {
    setSubmitDisabled(true)
    handleSubmit()
  }, 1000)

  return (
    <div className="account">
      <div className="account__wrapper signup">
        <div className="login-logo">
          <img alt="logo" src={logo} />
        </div>
        <div className="account__card">
          <div className="account__head">
            {role.includes('artist') ? (
              <h3 className="account__title">
                {t('signup.signUpAs')}&nbsp;
                <span className="account__logo-accent">
                  {t('sidebar.artist')}
                </span>
              </h3>
            ) : (
              <h3 className="account__title">
                {t('signup.become')}{' '}
                <span className="account__logo-accent">
                  {t('sidebar.curator')}
                </span>
              </h3>
            )}
          </div>
          {role.includes('curator') && (
            <>
              <span className="text__center">
                <p>{t('signup.wePay')}</p>
              </span>
              <span className="text__center">
                <p className="bold-text">{t('signup.condition')}</p>
              </span>
            </>
          )}
          <a
            className="btn btn-success account__btn account__btn--small"
            href={APP.SPOTIFY_AUTH_API}
          >
            <SpotifyIcon />
            &nbsp;
            {t('signup.signUpWithSpotify')}
          </a>
          <span className="text_center">
            <p className="conditions">{t('signup.permission')}</p>
            {role.includes('artist') && (
              <div
                className="account__or"
                data-cy="account__or-sign-up-easily-using"
              >
                <p>{t('login.easilyUsing')}</p>
              </div>
            )}
            {role.includes('curator') && (
              <p className="conditions">{t('signup.agree')}</p>
            )}
            {role.includes('artist') && (
              <SignUpForm
                role={role}
                submitDisabled={submitDisabled}
                onSubmit={debouncedSubmit}
              />
            )}
          </span>
          <div className="text__center">
            <Link to="/">{t('signup.alreadyHaveAccount')}</Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SignUp
